import { get as getFromStorage, remove as removeFromStorage, set as setInStorage } from 'lib/storage/isomorphicLocalStorage'

// Records which flow established the current session. Authoritative signal for
// "was this an Auth V2 login" — NOT the presence of an oidc.user:* key, which can
// linger after a stale v2 session and would misroute a v1 logout to the OIDC
// end-session endpoint. Kept free of any oidc-client-ts import so the always-loaded
// login choke points don't pull the library into every brand's bundle.
export const AUTH_METHOD_STORAGE_KEY = 'auth_method'
export const OIDC_AUTH_METHOD = 'oidc'
export const OIDC_USER_STORAGE_PREFIX = 'oidc.user:'

export const markOidcSession = (): void => {
  setInStorage(AUTH_METHOD_STORAGE_KEY, OIDC_AUTH_METHOD)
}

export const clearAuthMethodMarker = (): void => {
  removeFromStorage(AUTH_METHOD_STORAGE_KEY)
}

export const isOidcSession = (): boolean => getFromStorage(AUTH_METHOD_STORAGE_KEY) === OIDC_AUTH_METHOD

interface LoginSuccessAction {
  source?: App.SignUpAuthSource
  data?: { authMethod?: typeof OIDC_AUTH_METHOD }
}

// Reconciles the marker from a USER_LOGIN success. A v2 login sets it; a fresh v1
// sign-in (has `source`) clears it; a session-restore dispatch (initialiseUser /
// fetchUserData — no `source`) leaves it untouched, so the reload after the v2
// callback doesn't wipe it and misroute the next logout to the v1 path.
export const syncAuthMethodMarkerFromLogin = (action: LoginSuccessAction): void => {
  if (action.data?.authMethod === OIDC_AUTH_METHOD) {
    markOidcSession()
  } else if (action.source) {
    clearAuthMethodMarker()
  }
}
